"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUnit = void 0;

var http_1 = require("./http");

var uri = '/v4/data/units/';

function default_1(uuid, time, fields, credentials) {
  return http_1.authorizedHTTP(credentials).get(uri + uuid.string(), {
    params: {
      time: Math.floor(time.getTime() / 1000),
      fields: fields.join(",")
    }
  }).then(function (resp) {
    return resp.data;
  });
}

exports.default = default_1;

function createUnit(unit, credentials, manufacturing) {
  if (manufacturing != null) {
    return http_1.authorizedHTTP(credentials).post('/v3/data/units/new', {
      "unit": unit,
      "manufacturing": manufacturing
    }).then(function (resp) {
      return resp.data;
    });
  }

  return http_1.authorizedHTTP(credentials).post('/v3/data/units/new', {
    "unit": unit
  }).then(function (resp) {
    return resp.data;
  });
}

exports.createUnit = createUnit;